import Grid from '@mui/material/Grid';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import MainScreenMenuButtons from './mainScreenMenuButtons';
import MainScreenIcons from './mainScreenIcons';

const useStyles = makeStyles((theme) => {
    return {
        stickyHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingRight: 16,
            backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#222425',
        },
        actionBar: {
            marginTop: 15,
        },
        actionButtons: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
    };
});

const MainScreenBar = ({patient, disableSave, onSave, pastAttendances}) => {
    const classes = useStyles();

    return (
        <div
            id="action-bar-mainscreen"
            className={classes.actionBar}
        >
            <Grid item xs={12} className={classes.stickyHeader}>
                <Grid item xs={6} style={{display: 'flex', alignItems: 'center', gap: 10}}>
                    <MainScreenIcons patient={patient}/>
                </Grid>

                <Grid
                    item
                    xs={6}
                    className={classes.actionButtons}
                >
                    <MainScreenMenuButtons
                        patient={patient}
                        disableSave={disableSave}
                        onSave={onSave}
                        pastAttendances={pastAttendances}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default MainScreenBar;